<!-- 阶段涨幅 -->
<template>
  <div class="box">
    <check-row
      v-if="isHighEndEnjoy"
      text="按在售产品计算同类平均及同类排行"
      :is-checked="isChecked"
      :show-tip="true"
      @showTip="showTip"
      @changeSelect="changeSelect"
    />
    <common-list
      :header-list="listHeader"
      :data-source="getData()"
      :more-text="'至APP中查看更多 >>'"
      :more-link='moreLink'
      @clickMore="clickMore"
      ref="list"
    >
      <!--   上次更新时间   -->
      <template slot="header-item-extra">
        <p v-if="lastUpdateTime" class="last-update-time">{{
          lastUpdateTime
        }}</p>
      </template>
      <!--   列表数据   -->
      <template slot="list-item" slot-scope="{ item }">
        <div
          :class="[isHighEndEnjoy ? 'enjoy-item' : 'item']"
          @click="clickItem(item)"
        >
          <p style="text-align: left" class="date">{{
            item.date
          }}</p>
          <p
            :style="{
              color: highEndFundColor(item.rise),
              textAlign: 'center',
            }"
            class="rise"
            >{{ item.rise === "--" ? "--" : item.rise + "%" }}</p
          >
          <p
            v-if="isHighEndEnjoy"
            :style="{
              color: highEndFundColor(getSameTypeVal(item, 'value')),
              textAlign: 'center',
            }"
            class="same-type"
            >{{ getSameTypeVal(item, "value") }}</p
          >
          <div v-if="isHighEndEnjoy" class="rank">
            <div class="top">
              <p class="rank-text">{{ getSameTypeVal(item, "rank") }}</p>
              <p class="sc">{{ `/${getSameTypeVal(item, "total")}` }}</p>
              <img class="arrow-img" src="https://j5.dfcfw.com/sc/image/202305/20230529052234.png" />
            </div>
            <p
              class="level"
              :style="setDegreeColor(getSameTypeVal(item, 'level'))"
              >{{ getSameTypeVal(item, "level") }}</p
            >
          </div>
          <div v-else class="index-rise-box">
            <p
              :style="{ color: highEndFundColor(item.indexValue) }"
              style="text-align: right"
              class="index-rise"
              >{{
                isEmpty(item.indexValue) ? "--" : item.indexValue + "%"
              }}</p
            >
          </div>
        </div>
      </template>
    </common-list>
  </div>
</template>

<script>
import tool from '@/utils/tool';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import CheckRow from './CheckRow.vue';
import CommonList from './CommonList.vue';

export default {
  components: { CommonList, CheckRow },

  props: {
    fundCode: String, // 基金代码
    elementData: Object, // 组件数据
    mergeData: Object,
    indexInfo: {
      default: () => {},
      type: Object,
    },
  },

  data() {
    return {
      isFinish: false, // 是否点击了查看更多
      isChecked: false, // 是否选中radioBox
    };
  },

  computed: {
    isHighEndEnjoy() {
      // 是否为高端臻享
      return this.mergeData?.isHighEndEnjoy;
    },

    listHeader() {
      const commonHeader = [
        {
          name: '时间',
          style: {
            flex: 21,
            justifyContent: 'flex-start',
          },
        },
        {
          name: '涨跌幅',
          style: {
            flex: 21,
            justifyContent: 'center',
          },
        },
      ];
      return [
        ...commonHeader,
        ...(this.isHighEndEnjoy ? [{
          // 同类平均/在售同类平均
          name: this.isChecked ? '在售同类平均' : '同类平均',
          style: {
            flex: 32,
            justifyContent: 'center',
          },
        },
        {
          // 同类平均/在售同类平均
          name: this.isChecked ? '在售同类排行' : '同类排行',
          style: {
            flex: 26,
            justifyContent: 'flex-end',
          },
        }] : [{
          name: this.indexInfo?.indexName || '沪深300',
          style: {
            flex: 21,
            justifyContent: 'flex-end',
          },
        }]),
      ];
    },

    isFloatFund() {
      return this.elementData.isFloatProfit;
    },

    lastUpdateTime() {
      const stageRiseListInfo = this.mergeData?.stageRiseListInfo || {};
      const { lastUpdateTime } = { ...stageRiseListInfo };
      return lastUpdateTime;
    },
    moreLink() {
      return `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/fund-stage-increase/index?fundCode=${this.fundCode}&fundName=${this.elementData?.fundName}&pagetype=0&isGDLC=1&isSellChecked=${this.isChecked}`;
    },
  },

  watch: {
    indexInfo: {
      async handler() {
        if (isEmpty(this.mergeData)) {
          return;
        }
        if (!this.$refs.list) {
          await this.$nextTick();
        }
        // 非已售罄&候补：默认选中
        // 已售罄/候补：默认不选中
        this.isChecked = ![2, 3].includes(this.elementData?.sellState);
        // this.$refs.list.start();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    isEmpty,
    // 字体颜色
    highEndFundColor(value) {
      return tool.highEndFundColor(value);
    },

    // 查看更多
    clickMore() {
      this.$wxSendTrack('wxgdpzy.sy.gdjdzf.click', 'Click', { infoCode: this.fundCode, infoCodeType: 5 });
      this.isFinish = true;
    },

    getData() {
      console.log('===> getData', this.mergeData);
      const { isFinish } = this;
      // isChecked选中->在售同类平均&&在售同类排行；未选中>-同类平均&&同类排行；
      // 合并indexInfo数据和聚合接口
      const stageRiseListInfo = this.mergeData?.stageRiseListInfo || {};
      const { dataList } = { ...stageRiseListInfo };
      const mergeRes = dataList?.map((item) => {
        const target = (this.indexInfo?.stageRiseListIndexInfo || []).find(
          (info) => info.stageKey === item.stageKey,
        );
        return {
          ...item,
          ...target,
        };
      }) || [];
      console.log('===> mergeRes', mergeRes);
      return Promise.resolve(isFinish ? mergeRes : [...mergeRes].splice(0, 5));
    },

    changeSelect(isChecked) {
      this.isChecked = isChecked;
    },

    showTip() {
      const { updateDateCanBuy, updateDate } = this.indexInfo?.stageRiseListIndexInfo?.[0] ?? {};
      const updateTime = this.isChecked ? updateDateCanBuy : updateDate;
      multi.$feedback.showModal({
        content: `平台从产品策略维度划定同类范围，计算平均值、对比同类涨幅做参考。\n在售同类，指平台代销的、未售罄的同一策略的产品；同类，指平台代销的同一策略的产品。\n在售同类数值每个交易日定时更新，最新更新时间${isEmpty(updateTime) ? '--' : updateDate}。`,
        showCancel: false,
        confirmText: '知道了',
        confirmColor: '#e93801',
      });
    },

    getSameTypeVal(item, type) {
      const {
        rank,
        rankTotal,
        value,
        rankCanBuy,
        rankCanBuyTotal,
        valueCanBuy,
      } = item;
      if (type === 'rank') {
        return this.isChecked ? rankCanBuy : rank;
      }
      if (type === 'value') {
        const val = this.isChecked ? valueCanBuy : value;
        return isEmpty(val) ? '--' : `${numeral(val).format('0.00')}%`;
      }
      if (type === 'level') {
        const getLevel = (rankNow, sc) => {
          const descConfig = ['优秀', '良好', '一般', '不佳'];
          if (rankNow && sc) {
            if (parseFloat(rankNow) === 1) {
              return '优秀';
            }
            const index = Math.ceil((parseFloat(rankNow) * 4) / parseFloat(sc));
            if (index < 1 || index > 4 || Number.isNaN(index)) {
              return '--';
            }
            return `${descConfig[index - 1]}`;
          }
          return '';
        };
        return this.isChecked
          ? getLevel(rankCanBuy, rankCanBuyTotal)
          : getLevel(rank, rankTotal);
      }
      return this.isChecked ? rankCanBuyTotal : rankTotal;
    },

    setDegreeColor(level) {
      if (!isEmpty(level)) {
        if (['优秀', '良好'].includes(level)) {
          return {
            backgroundColor: 'rgba(250,89,20,0.1)',
            color: '#FF4400',
          };
        }
        if (level === '一般') {
          return {
            backgroundColor: 'rgba(255,185,0,0.15)',
            color: '#FAA614',
          };
        }
        return {
          backgroundColor: 'rgba(133,133,133,0.12)',
          color: '#666666',
        };
      }
      return {};
    },

    clickItem() {
      // 跳转二级页传参同头部策略标签
      const tagInfo = (this.mergeData.headerTags || []).find(
        (tag) => tag.isNSmallType,
      );
      const url = tagInfo?.linkInfo?.url ?? 'fund://mp.1234567.com.cn/weex/5cc0f0e04c6a48dea2270e6dbfaa35a3/pages/strategy-list/index?pageType=strategy';
      if (multi.$system.webPlatform === 'wxmp') {
        const source = `${url}&isShowSellout=${this.isChecked ? '0' : '1'}`;
        const convertUrl = tool.getJumpUrl(source);
        if (source === convertUrl) {
          this.$goFundApp();
          return;
        }
        wx.miniProgram.navigateTo({
          url: convertUrl,
        });
        return;
      }
      // 跳转高端臻享二级页&锚点
      multi.$router.push({
        // isShowSellout: '0'-勾选-不展示已售罄、候补中；'1'-未勾选-展示
        type: tagInfo?.linkInfo?.type ?? 2,
        url: `${url}&isShowSellout=${this.isChecked ? '0' : '1'}`,
      });
    },
  },
};
</script>

<style scoped>
.index-rise-box {
  flex: 21;
}

.index-rise {
  flex: 1;
  font-family: DINAlternate-Bold;
  font-size: 30px;
  line-height: 30px;
}

.arrow-img {
  margin-left: 2px;
  /* px2wx:change next */
  width: 32px;
  height: 32px;
}

.rank-text {
  font-family: DINAlternate-Bold;
  font-size: 28px;
  line-height: 28px;
  color: #000000;
  text-align: right;
}

.sc {
  font-family: DINAlternate-Bold;
  font-size: 28px;
  line-height: 28px;
  color: #808080;
  text-align: right;
}

.level {
  align-self: flex-end;
  font-family: PingFangSC-Regular;
  font-size: 22px;
  line-height: 22px;
  color: #000000;
  text-align: right;
  margin-top: 4px;
  margin-right: 32px;
  border-radius: 4px;
  padding: 4px;
  width: auto;
}

.top {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.check-row {
  display: flex;
  margin: 8px 0 0 24px;
  flex-direction: row;
  align-items: center;
}
.check-text {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #666666;
  line-height: 24px;
  font-weight: 400;
}
.image {
  /* px2wx:change next */
  width: 28px;
  height: 28px;
  margin-left: 16px;
}
.box {
  background-color: #ffffff;
  padding: 0 24px;
}

.last-update-time {
  font-family: PingFangSC-Regular;
  margin-left: 24px;
  font-size: 20px;
  color: #999;
  margin-bottom: 8px;
  margin-top: -12px;
}

.item {
  flex: 1;
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.enjoy-item {
  flex: 1;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
}

.date {
  flex: 21;
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
}

.rise,
.rank,
.same-type {
  font-family: DINAlternate-Bold;
  font-size: 28px;
  line-height: 28px;
  color: #000000;
}
.rise {
  flex: 21;
}
.same-type {
  flex: 32;
}
.rank {
  display: flex;
  flex-direction: column;
  flex: 26;
}
</style>
